// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { dblClick } from "@testing-library/user-event/dist/click";
import { getFirestore } from "firebase/firestore";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBoxQ4b7Qm6olwxI52GjMpMUion3p-Mwic",
  authDomain: "pharadb-1fa3c.firebaseapp.com",
  projectId: "pharadb-1fa3c",
  storageBucket: "pharadb-1fa3c.firebasestorage.app",
  messagingSenderId: "524809856380",
  appId: "1:524809856380:web:fa2e8ca42a68e839bd70f9",
  measurementId: "G-0DD08SMDYP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);

